import { useEffect } from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AdminWelcome() {
  const navigate = useNavigate();

  const admin =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("membre"))
      : null;

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/admin");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="fixed inset-0 z-[9999] w-screen h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-indigo-900 to-slate-900 text-white">

      
      <div className="absolute w-[500px] h-[500px] bg-indigo-500/20 blur-3xl rounded-full" />

      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        className="relative text-center space-y-8 px-6"
      >
        
        <motion.div
          initial={{ rotate: -20, scale: 0 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="flex justify-center"
        >
          <ShieldCheck size={110} className="text-green-400 drop-shadow-lg" />
        </motion.div>

        
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-wider uppercase">
          BIENVENUE {admin?.prenom?.toUpperCase() || "ADMIN"} 👑
        </h1>

        
        <p className="text-lg text-slate-300 tracking-wide">
          Espace Administrateur Sécurisé
        </p>

        
        <div className="w-80 max-w-full mx-auto h-2 bg-white/20 rounded-full overflow-hidden shadow-inner">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 5 }}
            className="h-full bg-green-400"
          />
        </div>

        <p className="text-sm text-slate-400">
          Redirection vers le tableau de bord...
        </p>
      </motion.div>
    </div>
  );
}
